document.addEventListener("DOMContentLoaded", function () {
    console.log("Archivo custom-cart.js cargado correctamente.");

    const giftWrapCheckbox = document.querySelector("#gift-wrap-checkbox");
    const giftWrapProductId = 49021105504572; // ID de la variante de envoltura

    if (giftWrapCheckbox) {
        console.log("Checkbox detectado y listo para escuchar eventos.");

        // Precargar el estado del checkbox según el carrito
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                const giftWrapItem = cart.items.find(item => item.id === giftWrapProductId);
                giftWrapCheckbox.checked = !!giftWrapItem;
                console.log("Estado inicial del checkbox:", giftWrapCheckbox.checked);
            })
            .catch(error => console.error("Error al obtener el carrito:", error));

        // Manejar los cambios en el checkbox
        giftWrapCheckbox.addEventListener("change", function (event) {
            const isChecked = event.target.checked;

            console.log("Estado del checkbox cambiado:", isChecked);

            if (isChecked) {
                // Agregar el producto si no está en el carrito
                addProductToCart(giftWrapProductId);
            } else {
                // Retirar el producto si está en el carrito
                removeProductFromCart(giftWrapProductId);
            }
        });
    }

    // Función para agregar el producto al carrito
    function addProductToCart(productId) {
        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: productId, quantity: 1 }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                console.log("Producto agregado al carrito:", data);
                refreshCartDrawer();
            })
            .catch(error => console.error("Error al agregar producto al carrito:", error));
    }

    // Función para retirar el producto del carrito
    function removeProductFromCart(productId) {
        fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: { [productId]: 0 } }),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                console.log("Producto eliminado del carrito:", data);
                refreshCartDrawer();
            })
            .catch(error => console.error("Error al retirar producto del carrito:", error));
    }

    // Función para refrescar el cart drawer
    function refreshCartDrawer() {
        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                console.log("Datos del carrito:", cart);

                // Disparar un evento para que el tema maneje la actualización del drawer
                document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
            })
            .catch(error => console.error("Error al refrescar el drawer del carrito:", error));
    }
});
